import type { Column, RowData } from '@tanstack/react-table';

import type { TDataTableFeatures } from '../DataTable/features/types/features.types.js';

/**
 * Gets the header's display value.
 * @param column - The column object.
 * @returns the label of the column header: string if available, or the label if it's a custom header; otherwise falls back to the column id.
 * @internal
 */
export function getColumnLabel<TData extends RowData>(
  column: Column<TDataTableFeatures, TData>,
): string {
  const { header, label } = column.columnDef;
  if (typeof header === 'string') {
    return header;
  }
  return label ?? column.id;
}
